import _ from "lodash";
import { MenuItem, Typography } from "@mui/material";
import React from "react";
import { TimeTableActionMenuProps } from "../../TimeTable.tsx";
import { Time, TimeMethods, TimeRangeMethods, toTimeRange } from "@jamezz/react-components";
import AddIcon from "@mui/icons-material/Add";
import TranslationWrapper from "../../../../old/beheer/components/TranslationWrapper/TranslationWrapper.tsx";
import { v7 } from "uuid";

export const AddTimeSlotAction = <T,>({
  onChange,
  openingHours,
  row,
  handleClose,
  defaultData,
}: Pick<TimeTableActionMenuProps<T>, "onChange" | "openingHours" | "row" | "defaultData"> & {
  handleClose: () => void;
}) => {
  return (
    <MenuItem
      onClick={() => {
        const newOpeningHours = _.cloneDeep(openingHours);

        const openingHoursForDay = _.last(openingHours[row.dayOrDate] ?? []);
        let start: Time = { hours: 12, minutes: 0 };
        if (openingHoursForDay) {
          const timeRange = toTimeRange(openingHoursForDay.hours);
          if (
            TimeMethods.isSame({ hours: 0, minutes: 0 }, timeRange.start) &&
            TimeMethods.isSame({ hours: 24, minutes: 0 }, timeRange.end)
          ) {
            openingHours[row.dayOrDate] = [];
          } else {
            start = toTimeRange(openingHoursForDay.hours).end;
          }
        }

        newOpeningHours[row.dayOrDate] = [
          ...(openingHours[row.dayOrDate] ?? []),
          {
            hours: TimeRangeMethods.timeRangeToString({ start, end: { hours: 0, minutes: 0 } }),
            id: v7(),
            data: defaultData,
          },
        ];
        onChange(newOpeningHours);
        handleClose();
      }}
    >
      <AddIcon />
      <Typography>
        <TranslationWrapper tKey={"Add timeslot"} tDefault={"Add timeslot"} />
      </Typography>
    </MenuItem>
  );
};
